import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import filesReducer from './slices/filesSlice';
import authReducer from './slices/authSlice';
import tutorialReducer from './slices/tutorialSlice';
import loadingReducer from './slices/loadingSlice';

const rootReducer = combineReducers({
  files: filesReducer,
  auth: authReducer,
  tutorial: tutorialReducer,
  loading: loadingReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['files', 'auth'], // Liste des reducers à persister
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
